import axios from '@/plugins/axios'

export default {
    getPageSpeedDetail(data){
        return axios({
            url: '/page-speed/get-pagespeed',
            method: 'post',
            data
        })
    },
    syncPageSpeed(){
        return axios({
            url: '/page-speed/sync-pagespeed-insight',
            method: 'post'
        })
    }
}
